import type { IconProps } from '../types/IconProps.ts';
export const SquareChevronDown: IconProps = {
    name: 'SquareChevronDown',
    children: [
        `<path d="m8 10 3.76 3.9c.13.13.35.13.48 0L16 10" />`,
        `<rect width="18" height="18" x="3" y="3" rx="1.5" />`,
    ]
};